import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { BackOfficeService } from 'src/app/services/back-office.service';
import { ExpressionValidation } from 'src/app/enums/expression-validation';
import { AuthService } from 'src/app/core/services/auth.service';
import Swal from 'sweetalert2';
import { EnvironmentService } from 'src/app/core/services/environment.service';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.scss']
})
export class PasswordChangeComponent implements OnInit {
  key: string;
  urlTienda: string;
  hideControls: boolean = true;
  formGroup: FormGroup;
  equalsPassword: string = null;
  warningMessage: string = null;
  passwordChange: boolean;
  boolActualizacionContrasena: boolean;

  formPasswordChangeClient: any = {
    password: '',
    idUserEncript: ''
  };
  formChangePasswordAdm: any = {
    oldPassword: '',
    newPassword: '',
  }
  constructor(
    private rutaActiva: ActivatedRoute,
    private formBuilder: FormBuilder,
    private backOfficeService: BackOfficeService,
    private authService: AuthService,
    private router: Router,
    private environmentService: EnvironmentService,
  ) { }

  ngOnInit() {
    this.createForm();
    this.rutaActiva.queryParams.subscribe(params => {
      this.key = params['key'] ? params['key'] : '';
      if (this.key != '') {
        this.hideControls = false;
        this.formGroup.get('oldPassword').disable();
      }
    });
  }
  createForm() {
    this.formGroup = this.formBuilder.group({
      oldPassword: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(20)]],
      newPassword: ['', [Validators.required, Validators.pattern(ExpressionValidation.PassWord)]],
      newRePassword: ['', [Validators.required]]
    });
    if (this.formGroup.get('newRePassword').value != this.formGroup.get('newPassword').value) {
      this.equalsPassword = 'Las contraseñas no coinciden';
    }
  }
  validPassword(value: string) {
    this.warningMessage = null;
    this.equalsPassword = null;
    this.formGroup.get('newRePassword').setErrors(null);
    if (value != this.formGroup.get('newRePassword').value && this.formGroup.get('newRePassword').value != '') {
      this.equalsPassword = 'Las contraseñas no coinciden';
      this.formGroup.get('newRePassword').setErrors([{ confirmedDoesNotMatch: true }]);
    }
    if (this.formGroup.get('newRePassword').value == '') {
      this.formGroup.get('newRePassword').setErrors([{ confirmedDoesNotMatch: true }]);
    }
    if (this.formGroup.get('newPassword').invalid && this.formGroup.get('newPassword').value != '') {
      this.warningMessage = 'Debe contener Minimo 6 caracteres,un valor númerico,Una mayúscula y minúscula y al menos un símbolo {$,#,%,&,@}.';
    }
  }
  validConfirmPassword(value: string) {
    this.equalsPassword = null;
    if (value != this.formGroup.get('newPassword').value && value != '') {
      this.equalsPassword = 'Las contraseñas no coinciden';
      this.formGroup.get('newRePassword').setErrors([{ confirmedDoesNotMatch: true }]);
    }
  }
  equalNewPassword(value: string) {
    this.warningMessage = null;
    this.equalsPassword = null;
    if (value != this.formGroup.get('newRePassword').value && this.formGroup.get('newRePassword').value != '') {
      this.equalsPassword = 'Las contraseñas no coinciden';
    }
    if (this.formGroup.get('newPassword').invalid && this.formGroup.get('newPassword').value != '') {
      this.warningMessage = 'Debe contener Minimo 6 caracteres,un valor númerico,Una mayúscula y minúscula y al menos un símbolo {$,#,%,&,@}.';
    }
  }
  changePassword() {
    Swal.fire({
      title: 'Aviso',
      text: '¿Está seguro de cambiar su contraseña?',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      confirmButtonText: 'Sí',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        if (this.key != '') {
          this.formPasswordChangeClient.password = this.formGroup.controls.newPassword.value;
          this.formPasswordChangeClient.idUserEncript = this.key;
          this.backOfficeService.changePasswordClient(this.formPasswordChangeClient)
            .subscribe(response => {
              if (response.valid) {

                this.urlTienda = this.environmentService.urlTiendaCatalogo;

                this.passwordChange = response.valid;
                this.boolActualizacionContrasena = response.valid;


                //Swal.fire('Confirmación', 'Se actualizó la contraseña satisfactoriamente', 'success').finally(() => {
                //  this.goToPortalWeb();
                //});
              } else {
                Swal.fire('Aviso', response.message, 'error');
              }
            });
        }
        else {
          this.formChangePasswordAdm.oldPassword = this.formGroup.controls.oldPassword.value;
          this.formChangePasswordAdm.newPassword = this.formGroup.controls.newPassword.value;
          this.backOfficeService.changeCurrentUserPassword(this.formChangePasswordAdm).subscribe(response => {
            if (response.valid) {
              Swal.fire('Confirmación', 'Se actualizó la contraseña satisfactoriamente', 'success').finally(() => {

                this.router.navigate(['/ofivirtual']);
              });
            } else {
              Swal.fire('Aviso', response.message, 'error');
            }
          })
        }
      }
    });
  }
  cancelPassword() {
    Swal.fire({
      title: 'Aviso',
      text: 'Se perderán los datos que no guardo. ¿Está seguro?',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      confirmButtonText: 'Sí',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        if (this.key == '') {
          this.router.navigate(['/ofivirtual']);
        }
        else {
          this.goToPortalWeb();
        }
      }
    })
  }

  goToPortalWeb() {
    window.location.href = this.backOfficeService.portalWebUrl();
  }
}